import cookie from "js-cookie";
import { getCookies } from "src/common/utils/user-session";
import { localiseUrlII } from "src/common/utils/format-localised-url";
import {
  getPaymentMethodSession,
  updatePaypalAddress,
  submitPaypalOrder,
} from "src/common/facades/eagle/checkout";
import logger from "src/logger";

export const createPaypalSession = async () => {
  try {
    const { orderId } = await getPaymentMethodSession(
      "paypal_checkout",
      getCookies(cookie)
    );
    return orderId;
  } catch (error) {
    logger.error(
      "Paypal checkout failed: Unable to create Paypal session on Eagle",
      error
    );
    throw error;
  }
};

export const updateShippingAddress = async (data) => {
  try {
    await updatePaypalAddress(data, getCookies(cookie));
    return true;
  } catch (error) {
    logger.error(
      "Paypal checkout failed: Unable to update Paypal address on Eagle",
      error
    );
    return false;
  }
};

export const submitOrder = async (data, country) => {
  try {
    await submitPaypalOrder(data, getCookies(cookie));
    window.location = localiseUrlII(country, "checkout-v2/paypal");
  } catch (error) {
    logger.error(
      "Paypal checkout failed: Unable to submit Paypal order on Eagle",
      error
    );
    throw error;
  }
};
